export const ADS_TYPES = [
  'FullScreenVideoAds',
  'FullScreenBannerAds',
  'FullScreenGoogleAds',
  'ContentAds',
  'BottomBannerAds',
  'BottomGoogleAds',
  'BottomVideoAds',
  'CardBannerAds',
  'CardGoogleAds',
  'FloatingAds',
];

export const ADS_CATEGORIES = [
  'googleAds',
  'taboolaAds',
  'customAds',
  'videoAds',
  'floatingAds',
];

export const CONTENT_TYPE = [
  'None',
  'ContentInfo',
  'ExternalContent'
];

export const MORE_VIEWS = ['WEBVIEW', 'APPVIEW', 'REDIRECT'];

export const CONTENT_CATEGORIES = [
  'ARTICLE',
  'VIDEO',
  'REEL',
  'SHORT_VIDEO',
  'NEWS',
  'WEB_STORY',
  'APPS',
  'GAMES',
];

export const LAYOUT_BOOL_FIELDS = [
  'autoScroll',
  'isAds',
  'ticker',
  'icon',
  'link',
  'image',
  'publisher',
  'verticalScroll',
  'horizontalScroll',
  'verticalTabs',
  'horizontalTabs',
  'isMore',
  'moreWebview',
  'pipEnable',
];

export const PAGE_SIZE_OPTIONS = [10, 20, 50];
